module["exports"] = [
  "###",
  "##",
  "#",
  "##a",
  "##b",
  "##c"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de_AT/address/building_number.js
// module id = 1331
// module chunks = 0